class IntlFreeShippingBar extends HTMLElement {
  static get observedAttributes() {
    return ['base-threshold', 'threshold-message', 'success-message']
  }

  constructor() {
    super()
    this._cartTotal = 0
    this._connected = false
  }

  connectedCallback() {
    this._connected = true
    this._load()
  }

  disconnectedCallback() {
    this._connected = false
  }

  attributeChangedCallback() {
    if (this._connected) this._load()
  }

  get _baseThreshold() {
    return parseInt(this.getAttribute('base-threshold') || '0', 10)
  }

  get _adjustedThreshold() {
    const base = this._baseThreshold
    const rate = window.Shopify?.currency?.rate
    if (rate && rate !== 1) {
      return Math.round(base * rate)
    }
    return base
  }

  _formatMoney(cents, currency = 'USD') {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(cents / 100)
  }

  async _load() {
    const base = this._baseThreshold
    if (base <= 0) return

    try {
      const res = await fetch('/cart.js')
      const cart = await res.json()
      this._cartTotal = cart.total_price
      this._render()
    } catch {
      this._render()
    }
  }

  _render() {
    const threshold = this._adjustedThreshold
    const cartTotal = this._cartTotal
    const currency = window.Shopify?.currency?.active || 'USD'

    if (cartTotal === 0) {
      this.innerHTML = ''
      return
    }

    const reached = cartTotal >= threshold
    const deficit = reached ? 0 : threshold - cartTotal
    const progress = threshold > 0 ? Math.min(100, (cartTotal / threshold) * 100) : 100
    const message = reached
      ? (this.getAttribute('success-message') || "You're eligible for free shipping!")
      : (this.getAttribute('threshold-message') || 'You\'re {{ amount }} away from free shipping!')
          .replace(/\{\{\s*amount\s*\}\}/gi, this._formatMoney(deficit, currency))

    this.innerHTML = `
      <div class="free-shipping-bar ${reached ? 'active' : ''}">
        <div class="free-shipping-container">
          <div class="free-shipping-bar__heading">
            <span class="free-shipping-bar__message">${message}</span>
          </div>
          ${!reached ? `<div class="free-shipping-bar__progressbar" style="--progress: ${progress}%">&nbsp;</div>` : ''}
        </div>
      </div>
    `
  }
}

customElements.define('intl-free-shipping-bar', IntlFreeShippingBar)
